var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag4SvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16191 10.0242C3.60955 7.78608 3.83336 6.66697 4.57292 5.94619C4.70961 5.81297 4.85749 5.69175 5.01492 5.58384C5.86674 5 7.00801 5 9.29054 5H10.7096C12.9922 5 14.1335 5 14.9853 5.58384C15.1427 5.69175 15.2905 5.81297 15.4273 5.94619C16.1668 6.66697 16.3906 7.78608 16.8383 10.0242C17.481 13.2376 17.8023 14.8442 17.0625 15.9827C16.9286 16.1889 16.7723 16.3796 16.5965 16.5513C15.6251 17.5 13.9866 17.5 10.7096 17.5H9.29054C6.01356 17.5 4.37507 17.5 3.40376 16.5513C3.22789 16.3796 3.07156 16.1889 2.93762 15.9827C2.19791 14.8442 2.51924 13.2376 3.16191 10.0242Z",
    stroke: "#2D3B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.5 8.33317C12.9602 8.33317 13.3333 7.96007 13.3333 7.49984C13.3333 7.0396 12.9602 6.6665 12.5 6.6665C12.0397 6.6665 11.6666 7.0396 11.6666 7.49984C11.6666 7.96007 12.0397 8.33317 12.5 8.33317Z",
    fill: "#2D3B36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.49996 8.33317C7.9602 8.33317 8.33329 7.96007 8.33329 7.49984C8.33329 7.0396 7.9602 6.6665 7.49996 6.6665C7.03972 6.6665 6.66663 7.0396 6.66663 7.49984C6.66663 7.96007 7.03972 8.33317 7.49996 8.33317Z",
    fill: "#2D3B36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.5 4.99984V4.1665C7.5 2.7858 8.61925 1.6665 10 1.6665C11.3807 1.6665 12.5 2.7858 12.5 4.1665V4.99984",
    stroke: "#2D3B36",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag4SvgrepoCom1);
export default __webpack_public_path__ + "static/media/bag-4-svgrepo-com 1.b248fcee98f9d894f94543324e882da3.svg";
export { ForwardRef as ReactComponent };